import axios from 'axios';
import qs from 'query-string';
import config from '../config'
import emailValidator from "email-validator";
import analytics from "./analytics";

export function getProductId() {

  let productId;

  if (process.env.NODE_ENV === 'production') {
    productId = window.cfProductId;
  } else { // Test product ID in development mode
    productId = config.devProductId;
  }

  return productId;

}

export function getRouterBasename() {

  let basename = "";

  if (process.env.NODE_ENV === 'production') {
    basename = window.cfBasename;
  }

  return basename;

}

export function addToCart({summary, productId, tableImg, editKey = false, deliveryTime = false}) {
  return axios.post(`/?wc-ajax=configurator_add_to_cart`, {
    summary,
    productId,
    tableImg,
    editKey,
    deliveryTime
  })
}

export async function sendConfigurationEmail(email, params) {

  if (!emailValidator.validate(email)) {
    throw new Error('invalid-email');
  }

  params = Object.keys(params).map((keyName) => ({
    attr: keyName,
    value: params[keyName].value
  }));

  return axios.post(`${config.apiBase}/send-configuration-email`, {
    email,
    params,
    productId: getProductId()
  }).then(({data}) => {
    analytics.onConfigurationEmail();
  }, () => {
    throw new Error('server-error');
  });

}

export async function sendContactUsRequest(email, name, message) {

  return axios.post(`${config.apiBase}/contact-us`, {
    email,
    name,
    message
  }).then(({data}) => {

  }, () => {
    throw new Error('server-error');
  });

}

export const preloadImage = async url => new Promise((resolve, reject) => {

  var img = document.createElement('img');
  img.src = url;

  img.onload = () => resolve(url);
  img.onerror = () => reject();

});


export function Error(type, message = '') {
  this.message = message;
  this.type = type
}

export function isMobile() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

export function getConfigurationLink(params) {

  let link = `${window.location.origin}${getRouterBasename()}/summary/`,
    paramsObj = {};

  Object.entries(params).forEach(([key, {value}]) => {
    paramsObj[key] = value;
  });

  return encodeURIComponent(`${link}?${qs.stringify(paramsObj, {encode: false})}`)

}

export function animate({draw, duration, complete}) {
  let start = performance.now();
  requestAnimationFrame(function animate(time) {
    let timeFraction = (time - start) / duration;
    if (timeFraction > 1) timeFraction = 1;
    let progress = timeFraction;
    draw(progress);
    if (timeFraction < 1) {
      requestAnimationFrame(animate);
    } else if (typeof complete === 'function') {
      complete();
    }
  });
}


export function timeout(duration) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, duration);
  })
}
